import { CapoPlugin } from "/home/les/dev/blob/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];